import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { WidgetFormComponent } from './widget-form/widget-form.component';
import { WidgetForumsComponent } from './widget-forums/widget-forums.component';
import { WidgetNewsComponent } from './widget-news/widget-news.component';
import { WidgetTimelineComponent } from './widget-timeline/widget-timeline.component';
import { WidgetPeerReviewComponent } from './widget-peer-review/widget-peer-review.component';
import { WidgetAdminReviewComponent } from './widget-admin-review/widget-admin-review.component';
import { WidgetEvaluationParticipantComponent } from './widget-evaluation-participant/widget-evaluation-participant.component';
import { WidgetContent1Component } from './widget-content-1/widget-content-1.component';
import { WidgetContent2Component } from './widget-content-2/widget-content-2.component';
import { WidgetEvaluationJudgeComponent } from './widget-evaluation-judge/widget-evaluation-judge.component';
import 'add-to-calendar-button';

@NgModule({
  declarations: [
    WidgetFormComponent,
    WidgetForumsComponent,
    WidgetNewsComponent,
    WidgetTimelineComponent,
    WidgetPeerReviewComponent,
    WidgetAdminReviewComponent,
    WidgetEvaluationParticipantComponent,
    WidgetEvaluationJudgeComponent,
    WidgetContent1Component,
    WidgetContent2Component
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    WidgetFormComponent,
    WidgetForumsComponent,
    WidgetNewsComponent,
    WidgetTimelineComponent,
    WidgetPeerReviewComponent,
    WidgetAdminReviewComponent,
    WidgetEvaluationParticipantComponent,
    WidgetEvaluationJudgeComponent,
    WidgetContent1Component,
    WidgetContent2Component
  ]
})
export class WidgetsModule {
  constructor() {}
 }
